import React from 'react';
import {
  Text,
  SitecoreContext,
  withSitecoreContext,
  ImageField,
  LinkFieldValue,
  Field,
  RichText,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import { ResponsiveImage, ResponsiveImageProps } from '../ResponsiveImage/ResponsiveImage';
import { SearchField, SearchFieldProps } from '../SearchField/SearchField';
import './index.scss';
import { SubscriptionMode } from '../Subscription/SubscriptionValidation/SubscriptionValidation';
import { getSubscriptionModeCookie } from '../../utils/authHelper';

// Params added to match new SearchField props requirement
type HeroBannerWithSearchProps = WithSitecoreContextProps & {
  fields: {
    'Title Text': Field<string>;
    'Additional Text': Field<string>;
    'Search Field Label': Field<string>;
    'Desktop Image': ImageField;
    'Mobile Image': ImageField;
    'Tablet Image': ImageField;
    PlaceholderText: Field<string>;
    ResultsPage: Field<LinkFieldValue>;
    DisplaySearchedQuery: Field<boolean>;
    IsMobileHeaderSearch: Field<boolean>;
    IsPageSearch: Field<boolean>;
    BrowseStatisticsReportText: Field<string>;
    BrowseTrainingText: Field<string>;
    SearchInfoText: Field<string>;
  };

  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

const HeroBannerWithSearch = ({
  fields,
  sitecoreContext,
}: HeroBannerWithSearchProps): React.JSX.Element => {
  let imageObj: ResponsiveImageProps = {
    responsiveFields: {
      MobileImageSrc: fields['Mobile Image'],
      DesktopImageSrc: fields['Desktop Image'],
    },
    sitecoreContext: sitecoreContext,
  };
  let searchObj: SearchFieldProps = {
    fields: {
      PlaceholderText: fields.PlaceholderText,
      ResultsPage: fields.ResultsPage,
      DisplaySearchedQuery: fields.DisplaySearchedQuery,
      IsMobileHeaderSearch: fields.IsMobileHeaderSearch,
      IsPageSearch: fields.IsPageSearch,
      BrowseStatisticsReportText: fields.BrowseStatisticsReportText,
      BrowseTrainingText: fields.BrowseTrainingText,
      SearchInfoText: fields.SearchInfoText,
    },

    sitecoreContext: sitecoreContext,
  };

  if (getSubscriptionModeCookie() === SubscriptionMode.Subscribed) {
    return <div className="HeroBanner"></div>;
  }

  if (fields) {
    return (
      <>
        {sitecoreContext.pageEditing && (
          <>
            <p>HeroBannerWithSearch Component Edit Mode</p>
          </>
        )}
        {
          <div className="HeroBanner">
            <div className="TextColumn">
              <div>
                <Text tag="h1" className="HeroHeading" field={fields['Title Text']} />
              </div>
              <RichText className="HeroAdditionalText" field={fields['Additional Text']} />
              <div className="search-field-container">
                <Text tag="span" field={fields['Search Field Label']} />
                <div className="component-container">
                  <SearchField
                    fields={searchObj.fields}
                    sitecoreContext={searchObj.sitecoreContext}
                  />
                </div>
              </div>
            </div>
            <div className="ImageContainer">
              <ResponsiveImage
                responsiveFields={imageObj.responsiveFields}
                sitecoreContext={imageObj.sitecoreContext}
              />
            </div>
          </div>
        }
      </>
    );
  } else if (!fields && sitecoreContext.pageEditing) {
    return <p>Please setup the Datasource.</p>;
  }

  return <></>;
};

export default withSitecoreContext()(HeroBannerWithSearch);
